<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="
            border-radius: 5px !important;
            padding-left: 0px;
            height: auto !important;
          " toggleable="lg" type="dark" variant="primary">
          <b-navbar-brand center>Freight Export Details</b-navbar-brand>
          <Filter-Agency-Modal />
          <FilterCBModal />
          <ClientCard />
           <ShipmentTrackCard />
          <b-button @click="goRolloverCont" size="sm" variant="success"
            style="font-size: 0.675rem ;margin-left: 5px;margin-bottom:4px;">Rollover Container</b-button>
          <b-button class="pull-right mr-2" v-if="FFExport.length > 0"
            :disabled="ExcelBtnName != 'Export As Excel' ? true : false" style="margin-left: auto"
            @click="getReports('FF_SEA_EXPORT', 'Export As Excel')" size="sm" variant="warning">{{ ExcelBtnName }}
            <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>

          <b-button class="pull-right" @click="gotoPendency()" size="sm" variant="primary">
            Show Pendency List
          </b-button>
          <b-button v-if="$sessionsStorage.get('employeeName') == 'RIMPLE KATHURIA'"
            class="pull-right mr-2 sline-reminder-btn"
            :disabled="isSendingReminder"
            @click="sendComprehensiveSlinePaymentReminder()"
            size="sm">
            <i v-if="!isSendingReminder" class="fa fa-paper-plane mr-1"></i>
            {{ slineReminderBtnName }}
            <b-spinner v-if="isSendingReminder" small class="ml-1"></b-spinner>
          </b-button>
        </b-navbar>
        <!-- 
        <div v-if="freight == true">
          <b-nav tabs>
            <b-nav-item disabled></b-nav-item>
            <b-nav-item
              :active="filtrActive == 0 ? true : false"
              @click="viewFFExportFCL('0', '0', '1', '1')"
              >All</b-nav-item
            >

            <b-nav-item
              style="width: 150px"
              :active="filtrActive == 1 ? true : false"
              @click="viewFFExportFCL('1', '0', '1', '1')"
              >Pending VGM Submission Date
              <b-badge variant="light">{{ totalVGMSubCount }}</b-badge>
            </b-nav-item>
 
          
            <b-nav-item
              style="width: 100px"
              :active="filtrActive == 3 ? true : false"
              @click="viewFFExportFCL('3', '0', '1', '1')"
              >Pending Handover
              <b-badge variant="light">{{ totalHandoverCount }}</b-badge>
            </b-nav-item>

            <b-nav-item
              style="width: 90px"
              :active="filtrActive == 4 ? true : false"
              @click="viewFFExportFCL('4', '0', '1', '1')"
              >Pending RailOut
              <b-badge variant="light">{{ totalRailCount }}</b-badge>
            </b-nav-item>

            <b-nav-item
              style="width: 150px"
              :active="filtrActive == 6 ? true : false"
              @click="viewFFExportFCL('6', '0', '1', '1')"
              >Pending SI Submission Date
              <b-badge variant="light">{{ totalSICount }}</b-badge>
            </b-nav-item>

            <b-nav-item
              style="width: 130px"
              :active="filtrActive == 7 ? true : false"
              @click="viewFFExportFCL('7', '0', '1', '1')"
              >Pending B/L Original Print
              <b-badge variant="light">{{ totalBLCount }}</b-badge>
            </b-nav-item>
         
          </b-nav>
        </div> -->

        <!-- <model-list-select
              @input="changePage"
              :list="pageList"
              v-model="changePageFilter"
              option-value="inv"
              option-text="int"
              placeholder="Select Status"
            ></model-list-select> -->

        <b-row>
          <b-col md="1">
            <b-button :variant="Filter.activeButtonFilter ? 'outline-danger' : 'outline-primary'"
              :class="'ml-4' + visible ? null : 'collapsed'" :aria-expanded="Filtervisible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="
                Filtervisible = !Filtervisible;
              clearBranchBtnFilter();
              ">{{ Filtervisible ? "Filter ON" : "Filter OFF" }}</b-button>
          </b-col>
          <b-col md="6" class="ml-4" v-if="Filtervisible">
            <b-button :pressed="activeButtonBranch" v-model="Filter.activeButtonFilter"
              :variant="activeButtonBranch ? 'success' : 'danger'" @click="BranchBtnFilter('Branch')">Branch {{
                activeButtonBranch ? " Filter On" : " Filter Off" }}</b-button>
            <b-button :pressed="activeButtonClient" v-model="Filter.activeButtonFilter"
              :variant="activeButtonClient ? 'success' : 'danger'" @click="BranchBtnFilter('Client')">Client {{
                activeButtonClient ? " Filter On" : " Filter Off" }}</b-button>
          </b-col>

          <b-col md="3" v-if="Filter.activeButtonFilter">
            <model-list-select @input="viewFFExportFCL('Normal', '0', '0', '1', '1')" :list="BranchInvStatusList"
              v-model="Filter.activeTallyBLFilter" option-value="inv" option-text="int"
              placeholder="Select Inv/BL Status"></model-list-select>
          </b-col>
          <b-col md="11">
            <!-- <b-button
              class="pull-right mb-1"
              v-if="FFExport.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('FF_SEA_EXPORT', 'Export As Excel')"
              size="sm"
              variant="warning"
              >{{ ExcelBtnName }}
              <b-spinner
                v-if="ExcelBtnName != 'Export As Excel'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button>

            <b-button
              class="pull-right mb-1 mr-2"
              @click="gotoPendency()"
              size="sm"
              variant="primary"
            >
              Show Pendency List
            </b-button> -->

            <!-- <Filter-Agency-Modal />
            <FilterCBModal />
            <ClientCard /> -->
          </b-col>
        </b-row>
        <div class="row align-items-end">
          <div class="col-md-4">
            <b-form-group style="margin-bottom: 0 !important">
              <b-input-group>
                <b-form-input :formatter="capitalizeAll" v-model="filter" @input="debounceSearch"
                  placeholder="Type To Search  (Assignment No. / Client / Container No./SB No. Shipper Inv No.)" />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>

          <div class="col-md-2">
            <label>Months/Year</label>
            <model-list-select @input="viewFFExportFCL('Normal', '0', '0', '1', '1')" :list="dateStatusList"
              v-model="dateStatusFilter" option-value="inv" option-text="int"
              placeholder="Select Date Filter"></model-list-select>
          </div>
          <div class="col-md-2">
            <label>Invoice Status</label>
            <model-list-select @input="viewFFExportFCL('Normal', '0', '0', '1', '1')" :list="invoiceStatusList"
              v-model="billingFilter" option-value="inv" option-text="int"
              placeholder="Select Status"></model-list-select>
          </div>
          <div class="col-md-2">
            <label>Sob Status</label>
            <model-list-select @input="viewFFExportFCL('Normal', '0', '0', '1', '1')" :list="SOBStatusList"
              v-model="SOBFilter" option-value="inv" option-text="int"
              placeholder="Select SOB Status"></model-list-select>
          </div>
          <div class="col-md-2">
            <label>Prealert Status</label>
            <model-list-select @input="viewFFExportFCL('Normal', '0', '0', '1', '1')" :list="PrealertStatusList"
              v-model="PrealertFilter" option-value="inv" option-text="int"
              placeholder="Select Prealert Status"></model-list-select>
          </div>
        </div>
        <div style="text-align: end">
          <h5 class="text-muted mt-2">
            <small v-if="isLoading == false">{{ totalRows }}Entries</small>
            <!-- {{ FFExport.length }}  -->
          </h5>
        </div>

        <!-- Main table element -->
        <div class="table-responsive tableMain">
          <b-table show-empty stacked="md" :items="FFExport" :fields="fields" :per-page="perPage" :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
            <template slot="ffExportFclId" slot-scope="row0" _rowVariant="danger">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
              <span v-if="row0.item.rollover_event_code == 1" :class="{
                alert: true,
                'alert-danger-text': row0.item.rollover_event_code == 1,
                blink: row0.item.rollover_event_code == 1,
              }"><br />This Event is Rollover</span>
            </template>
            <template slot="ffExportFclSeries" slot-scope="row11">
              <!-- {{row11.item}} -->

              <div class="text-left" :style="row11.item.seenExec == '0' ? 'color:red' : 'color:black'">
                <!-- @click="row11.item.finalBillingCompleted == 0?viewExportFCLPage(row11.item):''" -->
                <!-- {{'io'+row11.item.finalBillingCompleted+'io'}} -->
                <!--  -->

                <div :style="row11.item.seenExec == '0' ? 'color:red' : 'color:black'" @click="
                  row11.item.is_locked == '1' &&
                    (row11.item.finalBillingCompleted == 1 ||
                      row11.item.locked_counter > 0) &&
                    $sessionsStorage.get('designation') != 'Admin' &&
                    $sessionsStorage.get('nameUser') != 'Bhavneesh'
                    ? ''
                    : viewExportFCLPage(row11.item)
                  " class="showMoreData">
                  <b-badge v-if="row11.item.seenExec == '0'" variant="danger">New
                    <br />
                  </b-badge>

                  <span><b>{{ row11.item.ffExportFclSeries }}</b></span>

                  <br />
                  <span>Assignment Dt. : {{ row11.item.loginTime | moment }}</span>
                  <br />
                  <span>Raised From : {{ row11.item.raisedFrom }}<br /></span>
                  <span>By : {{ row11.item.raisedBy }}<br /></span>

                  <b-button style="font-size: 0.675rem" class="mt-2" size="sm" @click="
                    row11.item.is_locked == '1' &&
                      (row11.item.finalBillingCompleted == 1 ||
                        row11.item.locked_counter > 0)
                      ? LockUnLock(row11.item, 'locked')
                      : ''
                    " :variant="row11.item.is_locked == '1' &&
                      (row11.item.finalBillingCompleted == 1 ||
                        row11.item.locked_counter > 0)
                      ? 'danger'
                      : 'success'
                      "><b v-if="
                        row11.item.is_locked == '1' &&
                        (row11.item.finalBillingCompleted == 1 ||
                          row11.item.locked_counter > 0)
                      "><i class="fa fa-lock mr-1 lg"></i>LOCKED</b><b v-else><i
                        class="fa fa-unlock mr-1 lg"></i>UN-LOCKED</b></b-button><br />
                  <!-- <span ><b-badge variant="danger" v-if="row11.item.is_locked =='1' &&(row11.item.finalBillingCompleted==1 || row11.item.locked_counter>0)"><b>LOCKED</b></b-badge><b-badge variant="success" v-else><b>UN-LOCKED</b></b-badge><br/></span> -->
                  <!-- is_prealertSend &&(row11.item.finalBillingCompleted==0 || row11.item.locked_counter>0)-->
                  <!-- <span v-if="row11.item.finalBillingCompleted == '1'"
                    ><b :style="'color:black'">Billing : </b>
                    <b-badge variant="success"><b>Completed</b></b-badge
                    ><br
                  /></span>
                  <span v-if="row11.item.finalBillingCompleted == '0'"
                    ><b :style="'color:black'">Billing : </b>
                    <b-badge variant="danger"><b>Pending</b></b-badge
                    ><br
                  /></span> -->
                  <b :style="'color:black'">Billing : </b>
                  <b-badge variant="success" v-if="(row11.item.finalBillingCompleted == '1')">Billing
                    Completed</b-badge>
                  <b-badge v-else-if="row11.item.finalBillingCompleted == '4'" variant="success">Billing Completed -
                    Agent Expense Pending</b-badge>
                  <b-badge v-else variant="danger">Billing In-complete</b-badge><br />
                  <span v-if="row11.item.is_prealertSend == '1'"><b :style="'color:black'">Prealert Send : </b>
                    <b-badge variant="success"><b>YES</b></b-badge><br /></span>
                  <span v-if="row11.item.is_prealertSend == '0'"><b :style="'color:black'">Prealert Send : </b>
                    <b-badge variant="danger"><b>NO</b></b-badge><br /></span>
                  <span v-if="
                    row11.item.sob_date_detected != '' &&
                    row11.item.sob_date_detected != null
                  "><b :style="'color:black'">SOB : {{ row11.item.sob_date_detected }}</b>
                    <b-badge variant="danger"><b>SAILED</b></b-badge></span>
                  <b-badge v-if="
                    row11.item.SplitMergeCount != '' && row11.item.SplitMergeCount != 0
                  " variant="info"><b>Split Merge Activated</b></b-badge>
                </div>

                <!-- <div v-if="row11.item && row11.item.NotificationAlert2 && row11.item.NotificationAlert2.length > 0">
                  <div v-for="(item, index2) in row11.item.NotificationAlert2" :key="index2" class="status-alerts">
                    <span :class="{ 'alert alert-danger-text blink': true }">
                      <strong>{{ item.title }}</strong>
                      <template v-if="item.message">
                        - <strong>{{ item.message }}<br>{{ item.conclusion }}</strong>
                      </template>
</span>
<br>
</div>
</div>
<div v-else></div> -->

                <b-button class="mt-2" style="font-size: 0.675rem" size="sm" @click="showDocModal(row11.item)"
                  variant="outline-info">Summary & Documents</b-button>
                <br />
                <h7 class="mt-2" v-if="
                  row11.item.toSplitAssignmentNo && row11.item.newContainerFlow == '1'
                "><b-badge variant="info">Split of {{ row11.item.toSplitAssignmentNo }}</b-badge>
                </h7>
              </div>
               <InvExpSummary v-if="row11.item.allModuleId"
                  :PMC_title="'Inv Exp Summary Job No - ' + row11.item.ffExportFclSeries"
                  :PMC_JOBID="row11.item.allModuleId" :PMC_JOBNO="row11.item.ffExportFclSeries"
                  :PMC_JOBDATE="''" :PMC_JOBTYPE="''" :PMC_AgentType="''"
                  :PMC_Client="''" :PMC_Sline="''" />
              <Assignment-Summary :title="'Shipment Summary Tracking - '" :fk_all_module_id="row11.item.allModuleId"
                :jb_series="row11.item.ffExportFclSeries" />
              <ContainerSummary v-if="row11.item.allModuleId"
                :PMC_title="'Container Summary Job No - ' + row11.item.ffExportFclSeries"
                :PMC_JOBID="row11.item.allModuleId" :PMC_JOBNO="row11.item.ffExportFclSeries" :PMC_JOBDATE="''"
                :PMC_JOBTYPE="''" :PMC_AgentType="''" :PMC_Client="''" :PMC_Sline="''" />
              <JobWisePaymentsDetails
                  v-if="row11.item.allModuleId"
                  :allModuleId="Number(row11.item.allModuleId)"
                  :JobNo="row11.item.ffExportFclSeries"
                  />
              <RejectInvTallyBillSummary v-if="row11.item.allModuleId" :PMC_title="'Invoice Rejection Log Summary Job No - ' + row11.item.ffExportFclSeries
                " :PMC_JOBID="row11.item.allModuleId" :PMC_JOBNO="row11.item.ffExportFclSeries" :PMC_JOBDATE="''"
                :PMC_JOBTYPE="''" :PMC_Client="''" :PMC_Sline="''" />
              <MSDeleteRequest :item="row11.item" :JobNo="row11.item.ffExportFclSeries" :JobID="row11.item.allModuleId"
                :sessionsStorage="$sessionsStorage" @refreshData="handleRefresh" />
              <b
                v-if="row11.item.deleteRequestBy != '' && row11.item.deleteRequestBy != '0' && row11.item.deleteRequestBy != null">Requested
                By : {{ row11.item.deleteRequestBy }}<br /></b>
              <b
                v-if="row11.item.deleteArrovedBy != '' && row11.item.deleteArrovedBy != '0' && row11.item.deleteArrovedBy != null">Arroved
                By : {{ row11.item.deleteArrovedBy }}<br /></b>
              <WebhookLogSummary v-if="row11.item.allModuleId"
                :show-trigger-button="true"
                :PMC_title="'Webhook Log'"
                :PMC_JOBID="row11.item.allModuleId" :PMC_JOBNO="row11.item.ffExportFclSeries"
                :PMC_JOBDATE="''" :PMC_JOBTYPE="''" :PMC_AgentType="''"
                :PMC_Client="''" :PMC_Sline="''" />
              <AssignmentSplitMergeSummary v-if="row11.item.allModuleId"
                :PMC_title="'Assignment Split/Merge/Move Summary'"
                :PMC_JOBID="row11.item.allModuleId" :PMC_JOBNO="row11.item.ffExportFclSeries"
                :PMC_JOBDATE="''" :PMC_JOBTYPE="''" :PMC_AgentType="''"
                :PMC_Client="''" :PMC_Sline="''" />
            </template>
            <template slot="clientName" slot-scope="row2">
              <!-- <div v-if="row2.item && row2.item.NotificationAlert2 && row2.item.NotificationAlert2.length > 0">
                  <div v-for="(item, index2) in row2.item.NotificationAlert2" :key="index2" class="status-alerts">
                    <span :class="{ 'alert': true, 'alert-danger-text': item.type == 2, 'blink': item.type == 2 }">
                      <strong>{{ item.title }}</strong>
                      <template v-if="item.message">
                        - <strong>{{ item.message }}<br>{{ item.conclusion }}</strong>
                      </template>
</span>
<br>
</div>
</div>
<div v-else></div> -->

              <div class="status-alerts">
                <span :class="{
                  alert: true,
                  'alert-danger-text': row2.item.sub_noti_risk_verbose == 'High risk',
                  blink: row2.item.sub_noti_risk_verbose == 'High risk',
                }">
                  <span style="color: red" v-if="
                    row2.item.sub_noti_event_message != '' &&
                    row2.item.sub_noti_event_message != null
                  "><b>Event MSG : {{ row2.item.sub_noti_event_message }}</b></span><br />
                  <span style="color: red" v-if="
                    row2.item.status_verbose != '' && row2.item.status_verbose != null
                  "><b>Status Verbose : {{ row2.item.status_verbose }}</b></span><br />
                  <span v-if="
                    row2.item.sub_noti_risk != '' && row2.item.sub_noti_risk != null
                  "><b>Status : {{ row2.item.sub_noti_risk_verbose }}</b><br /></span>
                  <span v-if="
                    row2.item.sub_noti_risk != '' && row2.item.sub_noti_risk != null
                  "><b>Desc : {{ row2.item.sub_noti_risk_description }}</b><br /></span>
                </span>
              </div>
              <span>{{ row2.item.clientName }}</span>
            </template>
            <template slot="newfreightContainers" slot-scope="row5">
              <BookingTrack :containerArr="row5.item.newfreightContainers"
                :slineName="row5.item.slineName"
                :clientName="row5.item.clientName"
                :modal_title="`Container Movement Booking No: ${row5.item.validBookingNo} Job No - ${row5.item.ffExportFclSeries} Client: ${row5.item.clientName}`"
                :JOBNO="row5.item.ffExportFclSeries" :shipment_id="Number(0)" :subscription_id="Number(0)" :fk_sub_track_id="Number(0)"
                :fk_all_module_id="Number(row5.item.allModuleId)" :fk_booking_id="Number(row5.item.fk_booking_id)"
                :fk_container_id="Number(0)" :booking_number="row5.item.validBookingNo" :container_number="''" />
              <div v-if="row5.item.newContainerFlow == '1'">
                <div class="text-left" v-if="row5.item.newfreightContainers">
                  <div v-if="row5.item.newfreightContainers">
                    <span v-for="(item1, index) in row5.item.newfreightContainers.split(',')" :key="index">
                      <h6>
                        <b-badge variant="light">{{ item1 == "" ? "-------" : item1 }}
                        </b-badge>

                        <ContaierWebLogSummary v-if="row5.item.allModuleId && item1"
                          :PMC_title="'Container Event Summary Job No - ' + row5.item.ffExportFclSeries"
                          :PMC_JOBID="row5.item.allModuleId" :PMC_JOBNO="row5.item.ffExportFclSeries"
                          :PMC_CONTNO="item1" :PMC_JOBDATE="''" :PMC_JOBTYPE="''" :PMC_AgentType="''" :PMC_Client="''"
                          :PMC_Sline="''" />
                      </h6>
                    </span>
                  </div>
                </div>
                <div class="text-left" v-else>
                  <b-badge variant="light">-------</b-badge>
                </div>
              </div>
              <div v-if="row5.item.newContainerFlow == '0'">
                <div class="text-left" v-if="row5.item.freightContainers">
                  <div v-if="row5.item.freightContainers">
                    <span v-for="(item1, index) in row5.item.freightContainers.split(',')" :key="index">
                      <h6>
                        <b-badge variant="light">{{ item1 == "" ? "-------" : item1 }}
                        </b-badge>
                      </h6>
                    </span>
                  </div>
                </div>
                <div class="text-left" v-else>
                  <b-badge variant="light">-------</b-badge>
                </div>
              </div>
            </template>

            <template slot="newShipperInv" slot-scope="row56">
              <div v-if="row56.item.newContainerFlow == '1'">
                <div class="text-left" v-if="row56.item.newShipperInv">
                  <div v-if="row56.item.newShipperInv">
                    <span v-for="(item1, index) in row56.item.newShipperInv.split(',')" :key="index">
                      <h6>
                        <b-badge variant="light">{{ item1 == "" ? "-------" : item1 }}
                        </b-badge>
                      </h6>
                    </span>
                  </div>
                </div>
                <div class="text-left" v-else>
                  <b-badge variant="light">-------</b-badge>
                </div>
              </div>
              <div v-if="row56.item.newContainerFlow == '0'">
                <div class="text-left" v-if="row56.item.shipperInvNo">
                  <div v-if="row56.item.shipperInvNo">
                    <span v-for="(item1, index) in row56.item.shipperInvNo.split(',')" :key="index">
                      <h6>
                        <b-badge variant="light">{{ item1 == "" ? "-------" : item1 }}
                        </b-badge>
                      </h6>
                    </span>
                  </div>
                </div>
                <div class="text-left" v-else>
                  <b-badge variant="light">-------</b-badge>
                </div>
              </div>
            </template>

            <template slot="newSB" slot-scope="row564">
              <div v-if="row564.item.newContainerFlow == '1'">
                <div class="text-left" v-if="row564.item.newSB">
                  <div v-if="row564.item.newSB">
                    <span v-for="(item1, index) in row564.item.newSB.split(',')" :key="index">
                      <h6>
                        <b-badge variant="light">{{ item1 == "" ? "-------" : item1 }}
                        </b-badge>
                      </h6>
                    </span>
                  </div>
                </div>
                <div class="text-left" v-else>
                  <b-badge variant="light">-------</b-badge>
                </div>
              </div>
              <div v-if="row564.item.newContainerFlow == '0'">
                <div class="text-left" v-if="row564.item.shippingBillNo">
                  <div v-if="row564.item.shippingBillNo">
                    <span v-for="(item1, index) in row564.item.shippingBillNo.split(',')" :key="index">
                      <h6>
                        <b-badge variant="light">{{ item1 == "" ? "-------" : item1 }}
                        </b-badge>
                      </h6>
                    </span>
                  </div>
                </div>
                <div class="text-left" v-else>
                  <b-badge variant="light">-------</b-badge>
                </div>
              </div>
            </template>

            <template slot="POR" slot-scope="row10">
              <span>Stuffing :-
                {{
                  row10.item.stuffingType == "warehouseStuffing"
                    ? "WAREHOUSE"
                    : "FACTORY"
                }}<br /></span>
              <span>S-Line :- {{ row10.item.shippingLine }}</span>
              <br />
              <span>POR :- {{ row10.item.POR }}</span>
              <br />
              <span>LP :- {{ row10.item.LP }}</span>
              <br />
              <span>POD :- {{ row10.item.POD }}</span>
              <br />
              <span>FPOD :- {{ row10.item.FPOD }}</span>
              <br />
              <span :style="row10.item.SubscriptionId ? 'color: blue;font-weight:bold' : ''"
                @click="row10.item.SubscriptionId ? goToSubscriptionPage(row10.item) : ''">Booking No. :- {{
                  row10.item.validBookingNo }}</span>
              <br />
            </template>

            <!--  <template slot="loginTime" slot-scope="row3">
              <b-button
                v-if="accounts==true"
                @click="goToSlinePay(row3.item)"
                size="sm"
                variant="outline-danger"
              >Sline Payment</b-button>
            <b-dropdown
                      @click="viewFFExportFCL"
                      right
                      size="sm"
                      variant="outline-success"
                      id="dropdown-1"
                      text="GO TO"
                      class="m-md-2"
                    >
                      <b-dropdown-item
                        :disabled="bookPageId=='0'?true:false"
                        @click="gotToPage('BOOK')"
                      >Booking</b-dropdown-item>
                      <b-dropdown-item
                        :disabled="execPageId=='0'?true:false"
                        @click="gotToPage('EXEC')"
                      >Execution</b-dropdown-item>
                      <b-dropdown-item
                        :disabled="vgmPageId=='0'?true:false"
                        @click="gotToPage('VGM')"
                      >VGM</b-dropdown-item>

                      <b-dropdown-item
                        :disabled="handoverPageId=='0'?true:false"
                        @click="gotToPage('HAND')"
                      >Handover & Rail-Out</b-dropdown-item>
                      <b-dropdown-item
                        :disabled="sailPageId=='0'?true:false"
                        @click="gotToPage('SAIL')"
                      >Sail & FPOD</b-dropdown-item>
                      <b-dropdown-item
                        :disabled="ladingPageId=='0'?true:false"
                        @click="gotToPage('LADING')"
                      >Bill Of Lading</b-dropdown-item>
              </b-dropdown>
            </template>-->
            <template slot="invoiceStatus" slot-scope="row33">
              <b v-if="row33.item.isfinalsalesBillingComplete != 0" :style="row33.item.isfinalsalesBillingComplete == '1'
                ? { color: 'green' }
                : { color: 'red' }
                ">{{
                  row33.item.isfinalsalesBillingComplete == 1 ? "Not To Be Billed" : "--"
                }}</b>
              <b v-else :style="row33.item.invoiceStatus == '0' ? { color: 'green' } : { color: 'red' }
                ">{{
                  !row33.item.invoiceStatus
                    ? "--"
                    : row33.item.invoiceStatus == "1"
                      ? "In-Progress"
                      : row33.item.invoiceStatus == "0"
                        ? "Sent To Accounts"
                        : "--"
                }}</b>
              <!-- {{row33.item}} -->
              <b v-if="row33.item.sentForApproval && row33.item.sentForApproval == '1'">
                <br />
                Sent for Approval
              </b>
              <b v-if="
                row33.item.chnageApprovalStatus &&
                row33.item.chnageApprovalStatus == '1'
              ">
                <br />
                Was Sent for Approval and got Approved
              </b>
              <b v-if="
                row33.item.chnageApprovalStatus &&
                row33.item.chnageApprovalStatus == '2'
              ">
                <br />
                Was Sent for Approval and got Rejected
              </b>
            </template>
            <template slot="eta_details" slot-scope="row321">
              <span v-if="row321.item.ETA_destination_estimated != ''">Tentative : {{
                row321.item.ETA_destination_estimated }}</span>
              <span v-if="row321.item.ETA_destination_actual != ''"><br />Actual : {{ row321.item.ETA_destination_actual
              }}</span>
            </template>
            <template slot="show_details" slot-scope="row4">
              <span style="color: red" v-if="row4.item.status_verbose != '' && row4.item.status_verbose != null"><b
                  :style="'color:black'">Status Verbose : {{ row4.item.status_verbose }}</b></span>
              <b-form-checkbox v-if="row4.item.newContainerFlow == '0'" @change="row4.toggleDetails"
                v-model="row4.detailsShowing"></b-form-checkbox>
              <span v-if="row4.item.sub_noti_risk != '' && row4.item.sub_noti_risk != null"><b
                  :style="'color:black'">Status : {{ row4.item.sub_noti_risk_verbose }}</b><br /></span>
              <span v-if="row4.item.sub_noti_risk != '' && row4.item.sub_noti_risk != null"><b
                  :style="'color:black'">Desc : {{ row4.item.sub_noti_risk_description }}</b><br /></span>
              <span v-if="row4.item.sub_noti_risk != '' && row4.item.sub_noti_risk != null"><b
                  :style="'color:black'">Conclusion : {{ row4.item.sub_noti_conclusion }}</b></span>
              <Add-Message :fk_all_module_id="row4.item.allModuleId" :fk_client_id="row4.item.clientId"
                :fk_pod_id="row4.item.PODLocationId" style="list-style-type: none" />
              <!-- v-if="
                  billLandingModel.blLandingId != '' &&
                  billLandingModel.blType == 'LinerBL'
                " -->

              <!-- (row4.item.finalBillingCompleted == 1 || -->
              <!-- row4.item.locked_counter > 0) && -->
              <!-- {{row4.item}} -->
              <b-button v-if="
                row4.item.is_locked == '1' &&
                row4.item.is_prealertSend == '1' &&
                row4.item.manifestcount <= 0
              " @click="sendMANIFESTATION(row4.item)" size="sm" variant="warning" style="font-size: 0.675rem">SEND
                MANIFESTATION</b-button>
            </template>
            <template slot="row-details" slot-scope="row4">
              <b-card style="background: whiteSmoke">
                <div class="col-md-4" v-if="freight == true">
                  <b-button size="sm" @click="goToDoc(row4.item.ffExportFclId)" variant="outline-info">View
                    Documents</b-button>
                  <br />
                  <b-button class="mt-2" @click="showSMModal(row4.item, 'S')" size="sm" variant="outline-primary">Split
                    Assignment</b-button>
                  <b-button class="mt-2" @click="showSMModal(row4.item, 'M')" size="sm" variant="outline-primary">Merge
                    Assignment</b-button>
                  <label>Assignment Split / Merge Details</label>
                  <div v-if="
                    row4.item.toSplitAssignmentNo != null &&
                    row4.item.toSplitAssignmentNo != ''
                  ">
                    <b>Split Details:</b>
                    <br />
                    <span>Splited To Assignment No.:
                      {{ row4.item.toSplitAssignmentNo }}</span>
                    <br />
                    <span>Container Type: {{ row4.item.splitContainer }}</span>
                    <br />
                    <span>No. of Containers: {{ row4.item.splitContainerCount }}</span>
                  </div>
                  <div v-else>
                    <b>Split Details:NA</b>
                  </div>
                  <div v-if="
                    row4.item.toMergeAssignmentNo != null &&
                    row4.item.toMergeAssignmentNo != ''
                  ">
                    <b>Merge Details:</b>
                    <br />
                    <span>Merged In Assignment No.: {{ row4.item.toMergeAssignmentNo }}</span>
                    <br />
                    <span>Container Type: {{ row4.item.mergeContainer }}</span>
                    <br />
                    <span>No. of Containers: {{ row4.item.mergeContainerCount }}</span>
                  </div>
                  <div v-else>
                    <b>Merge Details:NA</b>
                  </div>
                </div>

                <div v-if="freight == true" class="col-md-4">
                  <label>Documentation Progress</label>
                  <div v-if="row4.item.stuffingType != 'warehouseStuffing'">
                    <b>VGM Submission Date :</b>
                    <span :style="row4.item.vgmSubmissionDate != null ? 'Completed' : 'color:red'
                      ">{{
                        row4.item.vgmSubmissionDate != null ? "Completed" : "Pending"
                      }}</span>
                    <br />
                    <b>Gate-In Date :</b>
                    <span :style="row4.item.gateInDate != null
                      ? 'Completed'
                      : row4.item.vgmSubmissionDate != null
                        ? 'color:red'
                        : ''
                      ">{{
                        row4.item.gateInDate != null
                          ? "Completed"
                          : row4.item.vgmSubmissionDate != null
                            ? "Pending"
                            : "--"
                      }}</span>
                    <br />
                    <b v-if="
                      row4.item.portType == 'Icd' &&
                      (row4.item.stuffingType == 'factoryStuffing' ||
                        row4.item.stuffingType == 'warehouseStuffing')
                    ">Handover:</b>
                    <span v-if="
                      row4.item.portType == 'Icd' &&
                      (row4.item.stuffingType == 'warehouseStuffing' ||
                        row4.item.stuffingType == 'factoryStuffing')
                    " :style="row4.item.handoverToRailId != null
                      ? 'Completed'
                      : row4.item.gateInDate != null
                        ? 'color:red'
                        : '--'
                      ">{{
                        row4.item.handoverToRailId != null
                          ? "Completed"
                          : row4.item.gateInDate != null
                            ? "Pending"
                            : "--"
                      }}</span>
                    <br />
                    <b v-if="
                      row4.item.portType == 'Icd' &&
                      (row4.item.stuffingType == 'factoryStuffing' ||
                        row4.item.stuffingType == 'warehouseStuffing')
                    ">Rail Out :</b>
                    <span v-if="
                      row4.item.portType == 'Icd' &&
                      (row4.item.stuffingType == 'warehouseStuffing' ||
                        row4.item.stuffingType == 'factoryStuffing')
                    " :style="row4.item.ffRailOutId != null
                      ? 'Completed'
                      : row4.item.handoverToRailId != null
                        ? 'color:red'
                        : ''
                      ">{{
                        row4.item.ffRailOutId != null
                          ? "Completed"
                          : row4.item.handoverToRailId != null
                            ? "Pending"
                            : "--"
                      }}</span>
                    <!-- <br />
                    <b>Sail Out :</b>
                    <span
                      :style="item1.ffSailId!=null?'Completed':item1.ffRailOutId!=null?'color:red':''"
                    >{{item1.ffSailId!=null?'Completed':item1.ffRailOutId!=null?'Pending':'--'}}</span>-->
                  </div>
                  <div v-else>
                    <b>VGM Submission Date :</b>
                    <span :style="row4.item.wareVgmSub != null ? 'Completed' : 'color:red'">{{ row4.item.wareVgmSub !=
                      null ? "Completed" : "Pending" }}</span>
                    <br />
                    <b>Gate-In Date :</b>
                    <span :style="row4.item.wareGate != null
                      ? 'Completed'
                      : row4.item.wareVgmSub != null
                        ? 'color:red'
                        : ''
                      ">{{
                        row4.item.wareGate != null
                          ? "Completed"
                          : row4.item.wareVgmSub != null
                            ? "Pending"
                            : "--"
                      }}</span>
                    <br />
                    <b>Handover:</b>
                    <span :style="row4.item.handoverToRailId != null
                      ? 'Completed'
                      : row4.item.wareGate != null
                        ? 'color:red'
                        : '--'
                      ">{{
                        row4.item.handoverToRailId != null
                          ? "Completed"
                          : row4.item.wareGate != null
                            ? "Pending"
                            : "--"
                      }}</span>
                    <br />
                    <b>Rail Out :</b>
                    <span :style="row4.item.ffRailOutId != null
                      ? 'Completed'
                      : row4.item.handoverToRailId != null
                        ? 'color:red'
                        : ''
                      ">{{
                        row4.item.ffRailOutId != null
                          ? "Completed"
                          : row4.item.handoverToRailId != null
                            ? "Pending"
                            : "--"
                      }}</span>
                    <br />
                    <b>Sail Out :</b>
                    <span :style="row4.item.ffSailId != null
                      ? 'Completed'
                      : row4.item.ffRailOutId != null
                        ? 'color:red'
                        : ''
                      ">{{
                        row4.item.ffSailId != null
                          ? "Completed"
                          : row4.item.ffRailOutId != null
                            ? "Pending"
                            : "--"
                      }}</span>
                  </div>
                </div>

                <div v-if="freight == true" class="col-md-4">
                  <label>Customer Service</label>
                  <div v-if="row4.item.stuffingType != 'warehouseStuffing'">
                    <b>SI Submission Date :</b>
                    <span :style="row4.item.siSubmissionDate != null ? 'Completed' : 'color:red'
                      ">{{
                        row4.item.siSubmissionDate != null ? "Completed" : "Pending"
                      }}</span>
                    <br />
                    <b>B/L Original Print :</b>
                    <span :style="row4.item.fclBlId != null
                      ? 'Completed'
                      : row4.item.siSubmissionDate != null
                        ? 'color:red'
                        : ''
                      ">{{
                        row4.item.fclBlId != null
                          ? "Completed"
                          : row4.item.siSubmissionDate != null
                            ? "Pending"
                            : "--"
                      }}</span>
                  </div>
                  <div v-else>
                    <b>SI Submission Date :</b>
                    <span :style="row4.item.wareSi != null ? 'Completed' : 'color:red'">{{
                      row4.item.wareSi != null ? "Completed" : "Pending"
                    }}</span>
                    <br />
                    <b>B/L Original Print :</b>
                    <span :style="row4.item.fclBlId != null
                      ? 'Completed'
                      : row4.item.wareSi != null
                        ? 'color:red'
                        : ''
                      ">{{
                        row4.item.fclBlId != null
                          ? "Completed"
                          : row4.item.wareSi != null
                            ? "Pending"
                            : "--"
                      }}</span>
                  </div>
                </div>
              </b-card>
            </template>
          </b-table>
        </div>
        <h5>
          <b-row>
            <b-col md="12" class="my-1">
              <b-pagination limit="5" align="center" v-model="currentPage" :per-page="perPage" :total-rows="totalRows"
                @change="onPageChange($event)"></b-pagination>
            </b-col>
          </b-row>
        </h5>
      </b-card-text>
    </b-card>
    <b-modal id="modal-multi-3" hide-footer ref="confirmModal" title="Confirmation">
      <p class="my-1">
        {{
          mergeModal.actionType == "2"
            ? "Are you sure you want to Split this Assignment..!"
            : "Are you sure you want to Merge containers of this Assignment to selected Assignment..!"
        }}
      </p>
      <div>
        <b-button class="mt-3 pull-right" variant="outline-danger" @click="closeDialogConfirm">Cancel & Close</b-button>
        <b-button class="mt-3" :disabled="isLoading == true ? true : false" variant="outline-primary"
          @click="onCloseSubmit">Yes</b-button>
      </div>
    </b-modal>
    <div>
      <b-modal size="xl" no-close-on-esc no-close-on-backdrop scrollable id="myDIV" hide-footer ref="splitMergePop"
        :title="mergeModal.actionType == '2'
          ? 'Assignment Split Utility'
          : 'Assignment Merge Utility'
          ">
        <div class="d-block text-center">
          <b-card>
            <b-card-text>
              <div>
                <!-- <md-layout md-gutter class="labelMargtop">
                  <md-layout md-flex="5"></md-layout>

                  <md-layout md-flex="40">
                    <label>Client Name</label>
                    <model-list-select
                      @input="getSplitMergeData"
                      :list="clientList"
                      id="clientId"
                      v-model="mergeModal.clientId"
                      option-value="clientId"
                      option-text="clientName"
                      placeholder="Select Client "
                    ></model-list-select>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="45">
                    <label>Assignment No.</label>
                    <model-list-select
                      :isDisabled="mergeModal.clientId==''"
                      @input="dataOnFromAssignment"
                      :list="assigmnmentList"
                      id="clientId"
                      v-model="mergeModal.ffExportFclId"
                      option-value="ffExportFclId"
                      option-text="ffExportFclSeries"
                      placeholder="Select Assignment "
                    ></model-list-select>
                  </md-layout>
                </md-layout>-->
                <md-layout md-gutter>
                  <md-layout md-flex="20">
                    <label>Action</label>
                    <model-list-select isDisabled @input="getSplitAssignment" :list="actionList" id="actionType"
                      v-model="mergeModal.actionType" option-value="aV" option-text="aT"
                      placeholder="Select Action "></model-list-select>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="75" v-if="mergeModal.actionType == '2'">
                    <label>Assignment No.</label>
                    <model-list-select @input="getTomergeExecId" :list="mergeModal.actionType == '1'
                      ? toMergeAssignmentList
                      : dummySplitAssignment
                      " id="clientId" v-model="mergeModal.ffExportFclIdContainer" option-value="ffExportFclId"
                      option-text="ffExportFclSeries" placeholder="Select Assignment "></model-list-select>
                  </md-layout>
                </md-layout>
                <div class="gutr" fluid v-if="mergeModal.actionType == '1'">
                  <!-- User Interface controls -->
                  <b-row>
                    <b-col md="12" class="my-1">
                      <b-form-group>
                        <b-input-group>
                          <b-form-input :formatter="capitalizeAll" v-model="filter1" placeholder="Type To Search" />
                          <b-input-group-append>
                            <b-button :disabled="!filter1" @click="filter1 = ''">Clear</b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <!-- Main table element -->
                  <b-table responsive bordered show-empty stacked="md" :items="toMergeAssignmentList" :fields="fields1"
                    :current-page="currentPage1" :per-page="perPage1" :filter="filter1" :sort-by.sync="sortBy1"
                    :sort-desc.sync="sortDesc1" :sort-direction="sortDirection1" @filtered="onFiltered1">
                    <template slot="ffExportFclId" slot-scope="row0">
                      <span>{{ row0.index + 1 + (currentPage1 - 1) * perPage1 }}</span>
                    </template>
                    <template slot="loginTime" slot-scope="row1">
                      <b-form-radio :disabled="containerList.length > 0 ? true : false"
                        @change="onRadioMerge(row1.item.ffExportFclId)" v-model="mergeModal.ffExportFclIdContainer"
                        name="some-radios" :value="row1.item.ffExportFclId">Select</b-form-radio>
                    </template>
                  </b-table>

                  <b-row>
                    <b-col md="12" class="my-1">
                      <b-pagination limit="25" :total-rows="totalRows1" :per-page="perPage1" v-model="currentPage1"
                        class="my-0 pull-right" />
                    </b-col>
                  </b-row>
                </div>
                <hr class="hr-s" />
                <div class="box" v-if="FFExportContainers.length > 0">
                  <!-- <div class="box-header">
                      <h3 class="box-title"></h3>
                  </div>-->
                  <!-- /.box-header -->

                  <div class="box-body gutr">
                    <table id="po" class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Sr no</th>
                          <!-- <th>Assignment No.</th> -->
                          <th>Container No.</th>
                          <th>Net Weight</th>
                          <th>Gross Weight</th>
                          <th>Custom Seal No.</th>
                          <th>Line Seal No.</th>
                          <th>Select</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr :style="item1.seenExec == '0' ? 'color:red' : 'color:black'"
                          v-for="(item1, index) in FFExportContainers" :key="index">
                          <td>{{ index + 1 }}</td>

                          <!-- <td>{{item1.ffExportFclSeries}}</td> -->
                          <td>
                            <span>Container No. :</span>
                            <span class="mainClick">{{ item1.containerNo }}</span>
                            <br />
                            <span>Container Type :</span>
                            <span class="mainClick">{{ item1.containerType }}</span>
                          </td>
                          <td>{{ item1.netWeight }}{{ item1.weightUnit }}</td>
                          <td>{{ item1.grossWeight }}{{ item1.weightUnit }}</td>
                          <td>{{ item1.customSealNo }}</td>
                          <td>{{ item1.LineSealNo }}</td>
                          <td>
                            <md-checkbox class="md-primary" style="margin: 0px" :disabled="mergeModal.actionType == '1' &&
                              mergeModal.ffExportFclIdContainer == ''
                              ? true
                              : false
                              " @change="getMergeContainerData(item1, index)" v-bind:class="mergeFclContainers.indexOf(item1.ffExportFclId) >= 0
                                ? 'md-checked checkedNew' +
                                item1.ffExportFclId +
                                (index + 1)
                                : 'checkedNew' + item1.ffExportFclId + (index + 1)
                                " :md-value="item1.ffExportFclId" :name="'deptMas' + (item1.ffExportFclId + 1)"
                              :id="'deptMas' + (item1.ffExportFclId + 1)"></md-checkbox>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="gutr">
                    <b-button :disabled="containerList.length <= 0 ||
                      (FFExportContainers.length <= 1 && mergeModal.actionType == '2')
                      " variant="primary" class="pull-right ml-2" @click="mergeSubmit">Submit</b-button>
                    <b-button variant="outline-danger" class="pull-right" @click="closeMerge">Close</b-button>
                  </div>

                  <!-- /.box-body -->
                </div>
              </div>
            </b-card-text>
          </b-card>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal size="xl" id="doc" class="modal-dialog-doc" no-close-on-esc no-close-on-backdrop ref="doc-modal"
        hide-footer :title="'Assignment Summary & Documents - ' + JOBSERIES">
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal">Close
        </b-button>
      </b-modal>

      <!-- Added By Priyanshu Singh For Billing Close Section Start -->
      <b-modal id="modal-lock-conf" ref="modal-lock-conf" title="Reason for Open Locked Assignment" centered
        no-close-on-esc no-close-on-backdrop hide-footer>
        <h3>Confirmation</h3>
        <form ref="form">
          <b-form-group label="Remark" label-for="name-input" invalid-feedback="Name is required">
            <b-form-textarea :formatter="capitalizeAll" rows="5" id="name-input" v-model="lockReason"
              required></b-form-textarea>
          </b-form-group>
        </form>
        <b-button @click="closeLockUnLockConfirm" variant="danger"> Cancel</b-button>
        <b-button v-if="lockReason" :disabled="lock_button ? true : false" variant="success" class="pull-right"
          @click="ConfLock">Send</b-button>
      </b-modal>
      <!-- Added By Priyanshu Singh For Billing Close Section End -->
    </div>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="onCloseSubmit"
      ref="addPopSubmit"></md-dialog-confirm>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import ComprehensiveSlinePaymentReminderService from "../../services/ComprehensiveSlinePaymentReminderService.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DocForm from "../../component/allModuleForm/docLibrary.vue";
import AddMessage from "../allModuleForm/addMessage.vue";
import AssignmentSummary from "../common/assignmentSummary.vue";
import CommonService from "../../services/CommonService.js";
import FilterAgencyModal from "../allModuleForm/filterAgencyModal.vue";
import FilterCBModal from "../allModuleForm/filterCBModal.vue";
import ClientCard from "../common/clientCard.vue";
import ShipmentTrackCard from "../common/ShipmentTrackCard.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import ContaierWebLogSummary from "../common/moduleBasedContaierWebLogSummary.vue";
import WebhookLogSummary from "../common/WebhookLogSummary.vue";
import AssignmentSplitMergeSummary from "../common/AssignmentSplitMergeSummary.vue";
import RejectInvTallyBillSummary from "../common/moduleBasedRejectInvTallyBillSummary.vue";
import MSDeleteRequest from "../common/MSDeleteRequest.vue";
import BookingTrack from "../consoleBooking/bookingTrack.vue";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    if (globalPermissionStatus("Sea Freight")) {
      // if (
      //   this.$sessionsStorage.get("designation") == "Admin" &&
      //   this.$sessionsStorage.get("nameUser") == "Bhavneesh"
      // ) {
      this.checkUserLoginTime();
      // }
      this.$store.dispatch("setCurrentRoute", "/freightForward/ViewffExportFcl");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewFFExportFCL("Normal", "0", "0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      Filtervisible: false,
      activeButtonBranch: false,
      activeButtonClient: false,
      Filter: {
        activeButtonFilter: "",
        activeTallyBLFilter: "PendingInvoice",
      },
      BranchInvStatusList: [
        {
          inv: "PendingInvoice",
          int: "Invoice",
        },
        {
          inv: "PendingBL",
          int: "BL",
        },
      ],
      dateStatusList: [
        {
          inv: "125",
          int: "4 Month",
        },
        {
          inv: "186",
          int: "6 Month",
        },
        {
          inv: "248",
          int: "8 Month",
        },
        {
          inv: "300",
          int: "10 Month",
        },
        {
          inv: "367",
          int: "1 Year",
        },
        {
          inv: "734",
          int: "2 Year",
        },

        {
          inv: "0",
          int: "Global ALL",
        },
      ],

      lock_allModuleId: "",
      lock_ffExportFclId: "",
      lock_ffExportFclSeries: "",
      lock_Type: "",
      lockReason: "",
      is_locked: "",
      locked_counter: "",
      lock_button: false,

      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      fields: [
        {
          key: "ffExportFclId",
          label: "SN.",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "ffExportFclSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },

        {
          key: "clientName",
          label: "Client / Exporter Name",
          sortable: true,
          sortDirection: "desc",
          class: "text-left colwidth",
        },

        {
          key: "newfreightContainers",
          label: "Container",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        // {
        //   key: "freightContainersType",
        //   label: "Container Type",
        //   sortable: true,
        //   sortDirection: "desc",
        //   class: "text-left",
        // },
        {
          key: "newShipperInv",
          label: "Shipper Invoice",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "newSB",
          label: "Shipping Bill",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },

        {
          key: "POR",
          mainkey: "POR",
          label: "Other",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "invoiceStatus",
          mainkey: "invoiceStatus",
          label: "Invoice Status",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "eta_details",
          mainkey: "eta_details",
          label: "ETA Destination Details",
          class: "text-left",
        },
        {
          key: "show_details",
          mainkey: "stuffingType",
          label: "More Details/Status",
          sortable: true,
          sortDirection: "ASC",
        },
        // {
        //   key: "loginTime",
        //   label: "Action",
        //   sortable: true,
        //   sortDirection: "desc",
        //   class: "text-center"
        // }
      ],

      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      changePageFilter: "0",
      modalInfo: { title: "", content: "" },
      fields1: [
        {
          key: "ffExportFclId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "ffExportFclSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "freightContainers",
          label: "Container No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "loginTime",
          label: "Select Assignment",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      selectedTomerge: "",
      currentPage1: 1,
      perPage1: 2,
      totalRows1: 0,
      pageOptions1: [5, 10, 15],
      sortBy1: null,
      sortDesc1: false,
      sortDirection1: "desc",
      filter1: null,
      modalInfo1: { title: "", content: "" },
      filtrActive: 0,
      slineReminderBtnName: "Send Payment Reminder",
      isSendingReminder: false,
      accounts: globalPermissionStatus("Accounts"),
      freight: globalPermissionStatus("Sea Freight"),
      routePageId: "",
      isLoading: false,
      totalCount: "",
      totalCompleted: "",
      totalVGMSubCount: "",
      totalGateInCount: "",
      totalHandoverCount: "",
      totalRailCount: "",
      totalSailCount: "",
      totalSICount: "",
      totalBLCount: "",
      bookPageId: "",
      execPageId: "",
      vgmPageId: "",
      handoverPageId: "",
      sailPageId: "",
      ladingPageId: "",
      invoiceStatusList: [
        {
          inv: "1",
          int: "In-Progress",
        },
        {
          inv: "2",
          int: "Sent to Accounts",
        },
        {
          inv: "3",
          int: "Billing Not Started",
        },
        {
          inv: "4",
          int: "Not To Be Billed",
        },
        {
          inv: "",
          int: "All",
        },
      ],
      PrealertStatusList: [
        {
          inv: "1",
          int: "Yes",
        },
        {
          inv: "2",
          int: "No",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
      SOBStatusList: [
        {
          inv: "1",
          int: "Sailed",
        },
        {
          inv: "2",
          int: "Not Sailed",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
      pageList: [
        {
          inv: "0",
          int: "Old",
        },
        {
          inv: "1",
          int: "New",
        },
      ],
      billingFilter: "",
      dateStatusFilter: "125",
      SOBFilter: "3",
      PrealertFilter: "3",
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },

      FFExport: [],
      // Modal
      mergeClickCount: "0",
      mergeModal: {
        allModuleId: "",
        splitContainerCount: "",
        splitContainer: "",
        actionType: "",
        noOfContainers: "",
        conTypeIdForEnq: "",
        conTypeForEnq: "",
        mainffId: "",
        clientId: "",
        ffExportFclId: "",
        ffExportFclIdContainer: "",
        toMergeffExecutionId: "",
        mainEnquiryId: "",
        containerTypeIdQuotation: "",
        containerTypeQuotation: "",
        toMergeEnquiryId: "",
        ffShippingWiseId: "",
      },
      actionList: [
        { aV: "1", aT: "Merge" },
        { aV: "2", aT: "Split" },
      ],
      mergeFclContainers: [],
      mergerContainerTypeQuot: [],
      containerCountType: [],
      clientList: [],
      assigmnmentList: [],
      toMergeAssignmentList: [],
      dummySplitAssignment: [],
      showAssignmentTable: false,
      asignmentSeriesCount: "",
      debounce: null,
      showContainerTable: true,
      FFExportContainers: [],
      allClientContainerData: [],
      ffAssignmentQuotation: [],
      countArry: [],
      containerList: [],
      ExcelBtnName: "Export As Excel",
    };
  },

  mounted() { },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },

  components: {
    // Loading,
    CustomLoader,
    ModelListSelect,
    DocForm,
    AddMessage,
    AssignmentSummary,
    FilterAgencyModal,
    FilterCBModal,
    ClientCard,
    ShipmentTrackCard,
    ContainerSummary,
    InvExpSummary,
    JobWisePaymentsDetails,
    ContaierWebLogSummary,
    WebhookLogSummary,
    AssignmentSplitMergeSummary,
    BookingTrack,
    RejectInvTallyBillSummary,
    MSDeleteRequest,
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    sortOptions1() {
      // Create an options list from our fields

      return this.fields1
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  watch: {
    milestoneFiltersD: {
      handler(newVal, oldVal) { },
      deep: true,
    },
  },
  methods: {
    checkUserLoginTime() {
      // Fetch the user's login time from your database or wherever you store it
      const userLoginTime = new Date(this.$sessionsStorage.get("fcl_job_pendency"));
      const currentTime = new Date();
      const compareTime = 3 * 60 * 60 * 1000;

      // Calculate the time difference in milliseconds
      const timeDifference = currentTime - userLoginTime;

      // If the time difference is greater than 3 hours (in milliseconds)
      // if (timeDifference > 3 * 60 * 60 * 1000) {
      if (timeDifference > compareTime) {
        // Redirect the user to another page using Vue Router
        this.$router.push("/fclassignmentPendency");
      }
    },
    clearBranchBtnFilter() {
      this.Filter.activeButtonFilter = "";
      this.activeButtonBranch = false;
      this.activeButtonClient = false;
      if (this.Filter.activeButtonFilter) {
        this.viewFFExportFCL("Normal", "0", "0", "1", "1");
      }
    },
    BranchBtnFilter(type) {
      this.Filter.activeButtonFilter = type;
      if (type == "Branch") {
        this.activeButtonBranch = true;
        this.activeButtonClient = false;
      } else if (type == "Client") {
        this.activeButtonBranch = false;
        this.activeButtonClient = true;
      }
      this.viewFFExportFCL("Normal", "0", "0", "1", "1");
    },
    sendMANIFESTATION(item) {
      console.log("item=>", item);

      let payload = {
        itemCode: "checkFCLBlDetails",
        ffExportFclId: item.ffExportFclId,
      };
      CommonService.getAllBLDash(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.FLAG == true) {
              this.$sessionsStorage.set("sendManifest_ffFclallModuleId", "");
              this.$sessionsStorage.set("sendManifest_ffType", "");
              this.$forceUpdate();
              this.$sessionsStorage.set("sendManifest_ffType", "FF Export");
              this.$sessionsStorage.set(
                "sendManifest_ffFclallModuleId",
                item.allModuleId
              );
              this.$sessionsStorage.set("sendManifest_ffExportFclId", item.ffExportFclId);
              this.$router.push({
                path: "/freightForwarding/sendManifestation",
              });
            } else {
              this.alert.content = data.MSG1;
              this.$refs["addPop"].open();
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on All_BL_List Error: ", error);
        });
    },
    ConfLock() {
      if (this.lockReason) {
        this.isLoading = true;
        let tit = "";
        if (this.is_locked == 1) {
          this.is_locked = "0";
          tit = "Un-Locked";
        } else if (this.is_locked == 1) {
          this.is_locked = "1";
          tit = "Locked";
        }
        this.lock_button = true;
        let payload = {
          allModuleId: this.lock_allModuleId,
          lockReason: this.lockReason,
          update_keyVal: this.lock_ffExportFclId,
          assigmnmentSeries: this.lock_ffExportFclSeries,
          Type: this.lock_Type,
          is_locked: this.is_locked,
          locked_counter: this.locked_counter,
          table_name: "frght_ffexportfcl",
          update_key: "ffExportFclId",
          Title: tit,
          module_type: "FF FCL Export",
        };
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/locknnlockStatus.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.find == 1) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.$refs["addPop"].open();
              this.lock_button = false;
              this.viewFFExportFCL("Normal", "0", "1", "1");
              this.isLoading = false;
            }
            (this.lockReason = ""), this.$refs["modal-lock-conf"].hide();
          })
          .catch((error) => { });
      }
    },
    LockUnLock(items, type) {
      this.lock_allModuleId = items.allModuleId;
      this.lock_ffExportFclId = items.ffExportFclId;
      this.lock_ffExportFclSeries = items.ffExportFclSeries;
      this.lock_Type = type;
      this.is_locked = items.is_locked;
      this.locked_counter = items.locked_counter;
      console.log("Priyanshu Singh=>", items);
      // return false;
      this.$refs["modal-lock-conf"].show();
    },
    closeLockUnLockConfirm() {
      this.$refs["modal-lock-conf"].hide();
    },
    changePage() {
      if (this.changePageFilter == "0") {
        this.$router.push({
          path: "/freightForward/ViewffExportFcl",
        });
      } else {
        this.$router.push({
          path: "/freightForward/newViewffExportFcl",
        });
      }
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.viewFFExportFCL("Normal", "0", "0", "1", "1");

        // this.typing = null
        // this.message = event.target.value
      }, 1000);
    },
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.ffExportFclSeries;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewFFExportFCL("Normal", "0", CURRENT, "2", event);
    },
    filterClear() {
      this.filter = "";
      this.viewFFExportFCL("Normal", "0", "0", "1", "1");
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewFFExportFCL("Normal", "0", CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },
    goToDoc(ID) {
      this.$router.push({
        path: "/freightForwarding/ffDocListPage/" + ID + "/Export",
      });
    },
    gotoPendency() {
      this.$router.push({
        path: "/fclassignmentPendency",
      });
    },
    gotToPage(ID) {
      if (ID == "BOOK") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);

        this.$router.push({
          path: "/freightForward/ffBooking",
        });
      } else if (ID == "EXEC") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);
        this.$sessionsStorage.set("editFFExecutionId", this.execPageId);
        if (this.ffExoprtDetail.stuffingType == "factoryStuffing") {
          this.$router.push({
            path: "/freightForward/ffExecution",
          });
        } else {
          this.$router.push({
            path: "/freightForward/ffexecutionWareHouse",
          });
        }
      } else if (ID == "VGM") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);
        this.$sessionsStorage.set("editFFExecutionId", this.execPageId);
        this.$router.push({
          path: "/freightForward/vgmDetail",
        });
      } else if (ID == "HAND") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);
        this.$sessionsStorage.set("editFFExecutionId", this.execPageId);
        this.$router.push({
          path: "/freightForward/handoverToRail",
        });
      } else if (ID == "SAIL") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);
        this.$sessionsStorage.set("editFFExecutionId", this.execPageId);
        this.$router.push({
          path: "/freightForward/sailFPOD",
        });
      } else if (ID == "LADING") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);
        this.$sessionsStorage.set("editFFExecutionId", this.execPageId);
        this.$router.push({
          path: "/freightForward/fclBLofLanding",
        });
      }
    },
    onRadioMerge(id) {
      this.mergeModal.ffExportFclIdContainer = id;
      this.getTomergeExecId();
    },
    onFiltered1(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows1 = filteredItems.length;
      this.currentPage1 = 1;
    },
    // Modal
    getMergeContainerData(item, index) {
      let i = this.mergeFclContainers.indexOf(item);

      // let i = this.mergeFclContainers.findIndex(z => {
      //   return z.ffExecutionContainerId == z.ffExecutionContainerId;
      // });

      // return false;

      if (i >= 0) {
        this.mergeFclContainers.splice(i, 1);
        this.mergerContainerTypeQuot.splice(i, 1);
        this.containerCountType.splice(i, 1);
      } else {
        this.mergeFclContainers.push(item);
        this.mergerContainerTypeQuot.push(item.containerTypeId);
        this.containerCountType.push(item.containerType);
      }

      this.containerList = [];
      this.mergeFclContainers.map((x) => {
        let obj = {
          containerType: x.containerType,
          containerTypeId: x.containerTypeId,
          subtractContainerId: x.ffConId,
          count: 1,
        };

        let arrayCheck = this.containerList.findIndex((y) => {
          return y.containerTypeId == x.containerTypeId;
        });
        if (arrayCheck >= 0) {
          this.containerList[arrayCheck]["count"] =
            this.containerList[arrayCheck]["count"] + 1;
        } else {
          this.containerList.push(obj);
        }
      });

      this.mergeModal["containerTypeIdQuotation"] = this.mergerContainerTypeQuot.join();
      this.mergeModal["containerTypeQuotation"] = this.containerCountType.join();

      this.mergeModal.containerTypeIdQuotation = Array.from(
        new Set(this.mergeModal.containerTypeIdQuotation.split(","))
      ).toString();

      this.mergeModal.containerTypeQuotation = Array.from(
        new Set(this.mergeModal.containerTypeQuotation.split(","))
      ).toString();

      this.mergeModal.conTypeIdForEnq = "," + this.mergeModal.containerTypeIdQuotation;
      this.mergeModal.conTypeForEnq = "," + this.mergeModal.containerTypeQuotation;

      var counts = {};
      this.containerCountType.forEach(function (x) {
        counts[x] = (counts[x] || 0) + 1;
      });

      this.countArry = Object.values(counts);
      this.mergeModal["noOfContainers"] = "," + this.countArry.join();
      this.getTomergeExecId();
    },
    getSplitMergeData(filterIdD) {
      this.routePageId = filterIdD;
      $("#po").DataTable().destroy();
      if (this.mergerContainerTypeQuot.length <= 0) {
        this.FFExportContainers = [];
      }
      this.isLoading = true;
      let payload = {
        view: "view",
        DCfilterId: filterIdD,
        clientId: this.mergeModal.clientId,
        ffExportFclId: this.mergeModal.ffExportFclId,
        ffExportFclIdContainer: this.mergeModal.ffExportFclIdContainer,
        mainEnquiryId: this.mergeModal.mainEnquiryId,
        allModuleId: this.mergeModal.allModuleId,
        containerTypeIdQuotation: this.mergeModal.containerTypeIdQuotation,
        //   actionType: this.mergeModal.actionType
      };
      //  console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/viewMergeContainerTable.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data, "hj");
            if (data.ffExportContainerData.length > 0) {
              this.FFExportContainers = data.ffExportContainerData;
            } else {
              this.FFExportContainers = [];
            }
            if (data.allClientContainerData.length > 0) {
              this.allClientContainerData = data.allClientContainerData;
            } else {
              this.allClientContainerData = [];
            }

            if (data.ffAssignmentQuotation.length > 0) {
              this.ffAssignmentQuotation = data.ffAssignmentQuotation;
            } else {
              this.ffAssignmentQuotation = [];
            }

            this.asignmentSeriesCount = data.asignmentSeriesCount;

            if (data.clientdetail.length > 0) {
              this.clientList = data.clientdetail;
            } else {
              this.clientList = [];
            }
            if (data.fromMergeAssignmentList.length > 0) {
              this.assigmnmentList = data.fromMergeAssignmentList;
            } else {
              this.assigmnmentList = [];
            }

            if (data.toMergeAssignmentList.length > 0) {
              this.toMergeAssignmentList = data.toMergeAssignmentList;

              this.totalRows1 = this.toMergeAssignmentList.length;
              // this.mergeModal.toMergeffExecutionId =
              //   data.toMergeAssignmentList[0].ffExecutionId;
            } else {
              this.toMergeAssignmentList = [];
            }

            // this.JqueryFun();
            this.dataOnFromAssignment();
            this.getSplitAssignment();

            this.isLoading = false;
          }
        })
        .catch((error) => { });
    },
    getSplitAssignment() {
      if (this.mergeModal.actionType == "2") {
        this.dummySplitAssignment = [];

        let splitArry = this.assigmnmentList.filter((x) => {
          return x.ffExportFclId == this.mergeModal.ffExportFclId;
        });

        if (splitArry.length > 0) {
          this.mergeModal.splitAssignmentSeries =
            splitArry[0].ffExportFclSeries + "/A" + this.asignmentSeriesCount;
          // alert("split");
          let obj = {
            ffExportFclSeries:
              splitArry[0].ffExportFclSeries + "/A" + this.asignmentSeriesCount,
            ffExportFclId: splitArry[0].ffExportFclId,
          };
          this.dummySplitAssignment.push(obj);
          this.mergeModal.ffExportFclIdContainer = this.dummySplitAssignment[0].ffExportFclId;
        }
      }
      // this.viewFFExportFCL();
    },
    dataOnFromAssignment() {
      let EnqIdArry = this.assigmnmentList.filter((x) => {
        return x.ffExportFclId == this.mergeModal.ffExportFclId;
      });
      if (EnqIdArry.length > 0) {
        this.mergeModal.mainEnquiryId = EnqIdArry[0].mainEnquiryId;
        this.mergeModal.allModuleId = EnqIdArry[0].allModuleId;
      }

      // this.getSplitMergeData();
    },
    getTomergeExecId() {
      let dummyExIdArry = this.allClientContainerData.filter((x) => {
        return x.ffExportFclId == this.mergeModal.ffExportFclIdContainer;
      });

      console.log(
        this.mergeModal.ffExportFclIdContainer,
        "ll",
        this.allClientContainerData
      );
      if (dummyExIdArry.length > 0) {
        console.log(dummyExIdArry, "jjjj");
        this.mergeModal.toMergeffExecutionId = dummyExIdArry[0].ffExecutionId;
        if (this.mergeModal.actionType == "2") {
          //  alert("split");
          this.mergeModal.splitAssignmentSeries =
            dummyExIdArry[0].ffExportFclSeries + "/A" + this.asignmentSeriesCount;
        } else {
          this.mergeModal.splitAssignmentSeries = dummyExIdArry[0].ffExportFclSeries;
        }
      }

      let dummyEnqId = this.toMergeAssignmentList.filter((x) => {
        return x.ffExportFclId == this.mergeModal.ffExportFclIdContainer;
      });

      if (dummyEnqId.length > 0) {
        this.mergeModal.toMergeEnquiryId = dummyEnqId[0].mainEnquiryId;
        this.mergeModal.mainffId = dummyEnqId[0].mainffId;
        this.mergeModal.ffShippingWiseId = dummyEnqId[0].ffShippingWiseId;
      }

      if (this.mergeModal.actionType == "1" && this.mergeClickCount == "0") {
        this.getSplitMergeData();
        this.mergeClickCount = 1;
      }
      //
    },
    showSMModal(item, ID) {
      this.FFExportContainers = [];
      this.mergeModal.allModuleId = item.allModuleId;
      if (ID == "S") {
        this.mergeModal.actionType = "2";
      } else {
        this.mergeModal.actionType = "1";
      }

      this.mergeModal.clientId = item.clientId;
      this.mergeModal.ffExportFclId = item.ffExportFclId;

      this.dataOnFromAssignment(item.ffExportFclId);
      // this.mergeModal.mainEnquiryId=item.,

      this.$refs["splitMergePop"].show();
      this.getSplitMergeData();
    },

    mergeSubmit() {
      this.getSplitMergeData();
      this.$refs["confirmModal"].show();
    },
    closeMerge() {
      this.mergeModal.FFExportContainers = [];

      this.mergeModal.ffExportFclIdContainer = "";
      this.mergeFclContainers = [];
      this.toMergeAssignmentList = [];
      this.containerList = [];
      this.$refs["splitMergePop"].hide();
    },
    closeDialogConfirm() {
      this.mergeFclContainers = [];
      this.containerList = [];
      this.toMergeAssignmentList = [];
      this.mergeModal.ffExportFclIdContainer = "";
      this.$refs["confirmModal"].hide();
      this.$refs["splitMergePop"].hide();

      //this.getSplitMergeData();
    },
    onCloseSubmit() {
      this.mergeModal["containerList"] = this.containerList;

      this.mergeModal.containerList.map((x) => {
        this.mergeModal.splitContainer += x.containerType + ",";
        this.mergeModal.splitContainerCount += x.count + ",";
      });
      // this.isLoading = true;
      this.mergeModal["mergeFclContainers"] = this.mergeFclContainers;
      this.mergeModal["ffAssignmentQuotation"] = this.ffAssignmentQuotation;
      console.log(this.mergeModal);
      // return false;
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/addMergeContainers.php`,
        data: JSON.stringify(this.mergeModal),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.isLoading = false;
            if (data.msg == "Inserted and Updated Successfully") {
              if (this.mergeModal.actionType == "1") {
                this.alert.content = "Container Merged Successfully";
              } else {
                this.alert.content = "Assignment Splited Successfully";
              }
            } else {
              this.alert.content = "Failed To MERGE or SPLIT";
            }
            this.mergeFclContainers = [];
            this.toMergeAssignmentList = [];
            this.mergeModal.ffExportFclIdContainer = "";
            this.containerList = [];
            this.$refs["confirmModal"].hide();

            this.$refs["splitMergePop"].hide();
            this.viewFFExportFCL("Normal", "0", "0", "1", "1");
            this.$refs["addPop"].open();
          }
        })
        .catch((error) => { });
    },
    // Main Table
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goToSlinePay(item) {
      this.$sessionsStorage.set("editExportFCLId", item.ffExportFclId);
      if (item.stuffingType == "factoryStuffing") {
        this.$sessionsStorage.set("editFFExecutionId", item.factoryStufExecId);
      } else {
        this.$sessionsStorage.set("editFFExecutionId", item.wareHouseStufExecId);
      }

      this.$router.push({
        path: "/freightForward/ffSLinePaymentExport",
      });
    },
    sendComprehensiveSlinePaymentReminder() {
      this.isSendingReminder = true;
      this.slineReminderBtnName = "Sending Reminder...";

      ComprehensiveSlinePaymentReminderService.sendComprehensiveSlinePaymentReminder()
        .then((result) => {
          this.isSendingReminder = false;
          this.slineReminderBtnName = "Send Payment Reminder";
          const { status, data } = result;
          if (status == 200 && data && data.success) {
            this.alert.content = data.message || "Comprehensive Shipping Line Payment Reminder sent successfully!";
            this.$refs["addPop"].open();
          } else {
            this.alert.content = data.message || "Failed to send Shipping Line Payment Reminder.";
            this.$refs["addPop"].open();
          }
        })
        .catch((error) => {
          this.isSendingReminder = false;
          this.slineReminderBtnName = "Send Payment Reminder";
          console.error("Error sending comprehensive sline payment reminder:", error);
          let errMsg = "Something went wrong. Please try again.";
          if (error.response && error.response.data && error.response.data.message) {
            errMsg = error.response.data.message;
          }
          this.alert.content = errMsg;
          this.$refs["addPop"].open();
        });
    },
    goToMain() {
      this.$sessionsStorage.set("editExportFCLId", "");
      this.$router.push({
        path: "/freightForward/ffExportFcl",
      });
    },
    JqueryFun() {
      return $(function () {
        return $("#po").DataTable();
      });
    },

    viewExportFCLPage(item) {
      let SEEN = item.seenExec;
      let FCLID = item.ffExportFclId;

      if (SEEN != "1") {
        let paylod = {
          UpdateNotSeenToSeen: "yes",
          ffExportfclId: FCLID,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/updateExecutionToSeenAllModules.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
            }
          })
          .catch((error) => { });
      }

      if (item.newContainerFlow == "1") {
        this.$sessionsStorage.set("editExportFCLId", FCLID);
        this.$router.push({
          path: "/freightForward/newffExportFcl",
        });
      } else {
        this.$sessionsStorage.set("editExportFCLId", FCLID);
        this.$router.push({
          path: "/freightForward/ffExportFcl",
        });
      }
    },
    getReports(id, btnName) {
      if (id) {
        this.ExcelBtnName = "Downloading Please Wait .....";
        let payload = {
          excelId: id,
          view: "view",
          searchVal: this.filter,
          billingFilter: this.billingFilter,
          dateStatusFilter: this.dateStatusFilter,
          SOBFilter: this.SOBFilter,
          PrealertFilter: this.PrealertFilter,
          newContainerFlow: "0",
          optTypeTransport: this.$sessionsStorage.get("optTypeTransport")
            ? this.$sessionsStorage.get("optTypeTransport")
            : "",
          optAllModuleIdTransport: this.$sessionsStorage.get("optAllModuleIdTransport")
            ? this.$sessionsStorage
              .get("optAllModuleIdTransport")
              .replace(/^,/, "")
              .replace(/,$/, "")
            : "",
          Filter: this.Filter,
        };
        CommonService.getAllPendingReverseTallyList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              if (data.excelName) {
                if (id == "FF_SEA_EXPORT") {
                  this.ExcelBtnName = btnName;
                  window.location.href =
                    `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
                }
              }
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on All_BL_List Error: ", error);
          });
      }
    },
    goRolloverCont() {
      this.$router.push({
        path: "/ctt/rollover-event",
      });
    },
    goToSubscriptionPage(item) {
      if (item.SubscriptionId) {
        this.$router.push({
          path: "/tracking/ocean-insights/subscription/" + item.SubscriptionId,
        });
      }
    },
    handleRefresh() {
      this.viewFFExportFCL("Normal", "0", "0", "1", "1");
    },
    viewFFExportFCL(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.mergeFclContainers = [];
      this.containerList = [];
      this.toMergeAssignmentList = [];
      this.mergeModal.ffExportFclIdContainer = "";
      this.filtrActive = filterIdD;
      this.routePageId = filterIdD;

      this.isLoading = true;
      let payload = {
        view: "view",
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        billingFilter: this.billingFilter,
        dateStatusFilter: this.dateStatusFilter,
        SOBFilter: this.SOBFilter,
        PrealertFilter: this.PrealertFilter,
        newContainerFlow: "0",
        optTypeTransport: this.$sessionsStorage.get("optTypeTransport")
          ? this.$sessionsStorage.get("optTypeTransport")
          : "",
        optAllModuleIdTransport: this.$sessionsStorage.get("optAllModuleIdTransport")
          ? this.$sessionsStorage
            .get("optAllModuleIdTransport")
            .replace(/^,/, "")
            .replace(/,$/, "")
          : "",
        Filter: this.Filter,
        type: type,
      };
      console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/ViewffExportFcl_NewV3_VP.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);

            if (SEARCH != "2") {
              this.currentPage = 1;
              if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }
            if (data.ffExportDetails.length > 0) {
              this.FFExport = data.ffExportDetails;
            } else {
              this.FFExport = [];
            }
            if (
              this.$sessionsStorage.get("designation") == "Admin" &&
              this.$sessionsStorage.get("nameUser") == "Bhavneesh"
            ) {
              this.totalRows = data.totalData;
            } else {
              // this.totalRows = this.FFExport.length;
              this.totalRows = data.totalData;
            }
            this.totalCount = data.totalCount ? parseInt(data.totalCount) : 0;
            this.totalCompleted = data.totalCompleted ? parseInt(data.totalCompleted) : 0;
            this.totalVGMSubCount = data.totalVGMSubCount
              ? parseInt(data.totalVGMSubCount)
              : 0;
            this.totalGateInCount = data.totalGateInCount
              ? parseInt(data.totalGateInCount)
              : 0;
            this.totalHandoverCount = data.totalHandoverCount
              ? parseInt(data.totalHandoverCount)
              : 0;
            this.totalRailCount = data.totalRailCount ? parseInt(data.totalRailCount) : 0;
            this.totalSailCount = data.totalSailCount ? parseInt(data.totalSailCount) : 0;
            this.totalSICount = data.totalSICount ? parseInt(data.totalSICount) : 0;
            this.totalBLCount = data.totalBLCount ? parseInt(data.totalBLCount) : 0;
            this.bookPageId = data.SEA_FRGHT_Booking;
            this.execPageId = data.SEA_FRGHT_EXEC;
            this.vgmPageId = data.SEA_FRGHT_VGM;
            this.handoverPageId = data.SEA_FRGHT_RAIL;
            this.sailPageId = data.SEA_FRGHT_SAIL;
            this.ladingPageId = data.SEA_FRGHT_BLADING;
            this.JqueryFun();
            this.isLoading = false;
          }
        })
        .catch((error) => { });
    },
  },
};
</script>
<style scoped>
.colwidth {
  min-width: 200px !important;
}

a:not(.md-button):not(.md-bottom-bar-item):hover {
  text-decoration: none !important;
}

.status-alerts {
  font-size: 11px;
  /* display: flex; */
  flex-direction: column;
  /* margin-bottom: 20px; */
}

.alert {
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
  color: #fff;
}

.alert-danger-text {
  /* background-color: #d9534f; Bootstrap danger color */
  color: #d9534f;
  /* Bootstrap danger color */
}

.alert-info-text {
  color: #2a6fde;
  /* background-color: #2a6fde; Bootstrap danger color */
}

.alert-warning {
  background-color: #f0ad4e;
  /* Bootstrap warning color */
}

.alert strong {
  margin-right: 5px;
}

@keyframes blink {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

.blink {
  animation: blink 1s infinite;
  /* Adjust the duration as needed */
}

.sline-reminder-btn {
  font-size: 0.675rem;
  margin-left: 5px;
  margin-bottom: 4px;
  background: linear-gradient(135deg, #ff416c, #ff4b2b);
  border: none;
  color: white;
  border-radius: 4px;
  padding: 6px 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  box-shadow: 0 3px 6px rgba(255, 75, 43, 0.3);
  transition: all 0.3s ease;
}

.sline-reminder-btn:hover {
  background: linear-gradient(135deg, #ff4b2b, #ff416c);
  transform: translateY(-1px);
  box-shadow: 0 5px 12px rgba(255, 75, 43, 0.4);
  color: white;
}

.sline-reminder-btn:active {
  transform: translateY(1px);
  box-shadow: 0 2px 4px rgba(255, 75, 43, 0.2);
}

.sline-reminder-btn:disabled {
  background: #cccccc;
  box-shadow: none;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// ViewffExportFcl.vue?8eb33e22